import { Permission } from '@cims-online/shared'
import { FieldDesignChange } from '../../../FDCTrackerContext/types'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useFDCTrackerContext } from '../../../FDCTrackerContext'

export function useCreateOptions():
  | CreateHeaderActionOptions<FieldDesignChange>
  | undefined {
  const {
    payItemGlobalId,
    fieldDesignChanges,
    mutations: {
      submit: { toggle },
    },
  } = useFDCTrackerContext()
  if (payItemGlobalId) return undefined
  return {
    loading: fieldDesignChanges?.loading,
    entity: 'Field Design Change',
    permission: Permission.CreateFieldDesignChange,
    modal: { type: 'custom', toggle },
  }
}
